import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { ScheduleInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { createScheduleInput } from 'src/app/common-components/helpers/schedule-helper';
import { ScheduleDetailSaveModel } from '../../schedule-details/models/schedule-detail-save.model';
import { SaveSchedule, SaveScheduleVariables } from '../../schedule-details/queries/generated/SaveSchedule';
import { SaveScheduleMutation } from '../../schedule-details/queries/save-schedule.graphql';

@Injectable({ providedIn: 'root' })
export class AddScheduleApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}

   create(scheduleDetail: ScheduleDetailSaveModel): Observable<ExecutionResult<SaveSchedule>> {
      const fields: (keyof ScheduleInput)[] = ['name', 'description', 'accountId'];
      const schedule = createScheduleInput(scheduleDetail, fields);
      return this.apiService.query<SaveSchedule, SaveScheduleVariables>({
         query: SaveScheduleMutation,
         variables: {
            deletedClosedExceptionIds: [],
            deletedScheduleHourIds: [],
            schedule,
         },
      });
   }
}
